(() => {
 function localizeSourceMedia(){
  const mapping=window.zorinenSourceMedia||{};
  const resolve=value=>{
   if(!value)return null;
   try{return mapping[new URL(value,window.location.origin).pathname]||null}catch{return null}
  };
  document.querySelectorAll('img,video,source').forEach(element=>{
   const source=resolve(element.getAttribute('src'));
   if(source){
    element.setAttribute('src',source);
    // Source content often carries a tryhaloring.com responsive srcset. Once
    // the original is local, leaving it behind would still trigger remote CDN
    // requests at wider breakpoints.
    if(element.hasAttribute('srcset'))element.removeAttribute('srcset');
   }
   const poster=resolve(element.getAttribute('poster'));
   if(poster)element.setAttribute('poster',poster);
  });
 }
 function initialize(){
  localizeSourceMedia();
  const root=document.getElementById('zh-reference-content');if(!root)return;
  root.querySelectorAll('video-media').forEach(media=>{
   if(media.dataset.zorinenReady)return;media.dataset.zorinenReady='true';
   const play=()=>{let video=media.querySelector('video');if(!video){const template=media.querySelector('template');if(template){media.append(template.content.cloneNode(true));video=media.querySelector('video')}}
    if(video){video.controls=true;video.playsInline=true;video.preload='metadata';media.setAttribute('loaded','');media.setAttribute('playing','');const poster=media.querySelector(':scope>img');if(poster)video.poster=poster.currentSrc||poster.src;video.play().catch(()=>{});const button=media.querySelector(':scope>button');if(button)button.hidden=true}
   };
   const button=media.querySelector(':scope>button');if(button)button.addEventListener('click',play);else media.addEventListener('click',play,{once:true});
  });
  root.querySelectorAll('a[href*="tryhaloring.com/pages/"],a[href*="tryhaloring.com/products/"],a[href*="tryhaloring.com/collections/"]').forEach(a=>{const u=new URL(a.href);a.href=u.pathname+u.search+u.hash});
  root.querySelectorAll('[data-hv3rr-scroll]').forEach(track=>{
   if(track.dataset.zorinenReady)return;track.dataset.zorinenReady='true';
   const parent=track.closest('[id^="hv3rr-"]')||track.parentElement;
   const prev=parent.querySelector('[data-hv3rr-prev]'),next=parent.querySelector('[data-hv3rr-next]');
   const update=()=>{if(prev)prev.disabled=track.scrollLeft<=4;if(next)next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-4};
   const move=d=>track.scrollBy({left:d*((track.querySelector('.hv3rr-card')?.getBoundingClientRect().width||302)+18),behavior:'smooth'});
   prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
 document.addEventListener('shopify:section:load',initialize);
})();
